<template>
  <div class="main-app container">
    <div class="my-4 text-center">
      <router-link to="/">
        <img style="max-width: 100px;" src="../assets/logo.png">
      </router-link>
    </div>
    <div class="main-body mb-5" v-if="$User.isStaff || $route.fullPath.includes('epay/done') || $route.fullPath.includes('epay/error') || $route.fullPath.includes('epay/bank-data') || $route.fullPath.includes('epay/factor/')">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EpayMain'
}
</script>

<style scoped>
textarea.form-control {
  min-height: 100px;
}
hr{
  height: 0px !important;
  border: solid 1px #17a2b8 !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #17a2b8b8 !important;
  border-color: #17a2b8 !important;
}
.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.bg-info{
  color: #fff;
  background-color: #17a2b8 !important;
  border-color: #17a2b8 !important;
}
.btn-light {
  color: #000;
  background-color: whitesmoke;
  border-color: #f8f9fa;
}
label{
  font-weight: 600;
}
body{
  direction:rtl;
  text-align:center;
}
.main-body{
  text-align: right;
  margin: auto;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%);
  border-radius:16px;
  height: 100% !important;
  padding:10px;
  background: white;
}
.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: #41b883;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(65 189 132 / 9%);
}
.margin{
  margin-top:35px !important;
}
.button:hover{
  background-color:pink;
}
.form{
  padding: 20px;
  background: whitesmoke;
  border-radius: 24px;
  box-shadow: 4px 5px 15px 0px #c3c3c3;
}
.upida{
  margin-top:40px;
}
#page-link{
  direction:ltr;
}
.pointer{
  cursor: pointer;
}
</style>
